import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { RestrictionsProfileEffects } from './restrictions-profile.effects';
import { restrictionsProfileReducer } from './restrictions-profile.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('restrictionProfiles', restrictionsProfileReducer),
    EffectsModule.forFeature([RestrictionsProfileEffects]),
  ],
  providers: [],
})
export class RestrictionsProfileStoreModule {}
